import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Navbar, Nav, Image } from "react-bootstrap";
import { OrgInfo } from "@preveil-api";
import { AppConfiguration, Account, NavigationPath, NavigationPathTypes, OrgUserRoles, default_web_public_urls, account_types } from "src/common";
import { UserNavigation, SupportDropdown, SettingsDropdown, AccountDropdown, NotificationsButton } from "./components";
import express_logo from "src/assets/images/logos/preveil-express-logo.png";
import logo from "src/assets/images/logos/preveil-logo.png";

type AllProps = {
  current_account?: Account;
  organization?: OrgInfo;
  accounts?: Account[];
  type?: NavigationPathTypes;
  active_path?: string;
}
const is_web = AppConfiguration.buildForWeb();
function TopNavigationComponent(props: AllProps) {
  const { current_account, accounts, organization, type, active_path } = props;
  const current_location = useLocation();
  const [logo_src, setLogo] = useState<string>(getLogoSrc());
  const admin_enabled = !is_web && !!organization && organization.role === OrgUserRoles.admin;
  const pending_convert = current_account?.pending_account_type === account_types.express;

  // Description: Update on navigation if needed
  useEffect(() => {
    const _logo_src = getLogoSrc();
    _logo_src !== logo_src && setLogo(_logo_src);
  }, [current_location]);

  // NOTE: Will not be using web_logo
  function getLogoSrc() {
    return !is_web || (default_web_public_urls.includes(current_location.pathname)) ? logo : express_logo;
  }

  return <header id="preveil-header">
    <Navbar variant="dark" expand="md" fixed="top"  >
      <Container fluid>
        <Navbar.Brand href="/">
          <span className="d-none">PreVeil</span>
          <Image alt="PreVeil Logo" src={logo_src} />
        </Navbar.Brand>
        {
          !!current_account && !pending_convert &&
          <Nav className="mobile-user-nav">
            <UserNavigation type={type} admin_enabled={admin_enabled}/>
            {/* TO DO: Hide Notifications until ready to dev */}
            <NotificationsButton type={type} />
          </Nav>
        }
        <Navbar.Toggle aria-controls="top-navbar" />
        <Navbar.Collapse id="top-navbar" >
          <Nav className="user-nav hide-mobile">
            {!!current_account && !pending_convert && <UserNavigation type={type} admin_enabled={admin_enabled}/>}
          </Nav>
          <Nav>
            {
              !!current_account && !pending_convert ?
                <>
                  <NotificationsButton type={type} className="hide-mobile" />
                  <SupportDropdown />
                  <SettingsDropdown active={type === NavigationPath.SettingsNavigation} active_path={active_path} current_account={current_account} />
                  <AccountDropdown current_account={current_account}
                    accounts={accounts}
                    active={type === NavigationPath.MailNavigation} />
                </> :
                <SupportDropdown />
            }
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </header>;
}

export default React.memo(TopNavigationComponent);
